export default __webpack_public_path__ + "static/media/drag-icon.220150a1.svg";